import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, from } from 'rxjs';
import { ScriptInjectorService } from 'src/app/core/services/script-injector.service';
import { environment } from 'src/environments/environment';
import * as fromRoot from '../../../reducers';
import * as fromAuth from '../../../auth/reducers';

@Component({
  selector: 'portal-dashboard-folders-v3',
  templateUrl: './dashboard-folders-v3.component.html',
  styleUrls: ['./dashboard-folders-v3.component.scss']
})
export class DashboardFoldersV3Component implements OnInit {
  public clinicMessagingLoaded$: Observable<boolean>;
  public selectedLanguage$: Observable<string | null>;
  public xSalveClinicToken$: Observable<string | null>;

  constructor(
    private _store: Store<fromRoot.State>,
    private _scriptInjector: ScriptInjectorService
  ) {}

  ngOnInit() {
    this.selectedLanguage$ = this._store.pipe(select(fromAuth.getLanguageCode));
    this.xSalveClinicToken$ = this._store.pipe(select(fromAuth.getClinicId));
    this.clinicMessagingLoaded$ = from(
      this._scriptInjector
        .loadScript(
          'salve-clinic-messaging-dashboard',
          environment.messagingDashboardComponentUrl
        )
        .then(() => true)
        .catch(() => false)
    );
  }
}
